/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
import t from 'common/utils/translate';
import { ANIMATION_TRIGGER } from 'src/common/constants';

export enum EFFECT_ID {
	BG_COLOR = 'BG_COLOR',
	COLOR = 'COLOR',
	OPACITY = 'OPACITY',
	X = 'X',
	Y = 'Y',
	ROTATE = 'ROTATE',
	SCALE = 'SCALE',
	SCALE_X = 'SCALE_X',
	SCALE_Y = 'SCALE_Y',
}

export enum EASE_ID {
	POWER_0 = 'power_0',
	POWER_IN_1 = 'powerIn_1',
	POWER_OUT_1 = 'powerOut_1',
	POWER_IN_OUT_1 = 'powerInOut_1',
	BACK_IN = 'backIn',
	BACK_OUT = 'backOut',
	BACK_IN_OUT = 'backInOut',
	BOUNCE_IN = 'bounceIn',
	BOUNCE_OUT = 'bounceOut',
	BOUNCE_IN_OUT = 'bounceInOut',
}

export enum PRESET_ID {
	FADE_AND_SCALE = 'FADE_AND_SCALE',
	FADE_AND_ROTATE = 'FADE_AND_ROTATE',
	FADE_UP = 'FADE_UP',
	FADE_DOWN = 'FADE_DOWN',
	MOVE = 'MOVE',
}

export const EFFECT_LABELS = {
	[EFFECT_ID.OPACITY]: 'Opacity',
	[PRESET_ID.MOVE]: 'Move',
	[EFFECT_ID.X]: 'Move X',
	[EFFECT_ID.Y]: 'Move Y',
	[EFFECT_ID.ROTATE]: 'Rotate',
	[EFFECT_ID.SCALE]: 'Scale',
	[EFFECT_ID.SCALE_X]: 'Scale X',
	[EFFECT_ID.SCALE_Y]: 'Scale Y',
	[EFFECT_ID.COLOR]: 'Color',
	[EFFECT_ID.BG_COLOR]: 'Background color',
} as const;

export const PRESET_LABELS = {
	[PRESET_ID.FADE_UP]: 'Fade up',
	[PRESET_ID.FADE_DOWN]: 'Fade down',
	[PRESET_ID.FADE_AND_SCALE]: 'Fade and Scale',
	[PRESET_ID.FADE_AND_ROTATE]: 'Fade and Rotate',
	[PRESET_ID.MOVE]: 'Move',
} as const;

export const EASE_LABELS = {
	[EASE_ID.POWER_0]: 'Linear',
	[EASE_ID.POWER_IN_1]: 'PowerIn',
	[EASE_ID.POWER_OUT_1]: 'PowerOut',
	[EASE_ID.POWER_IN_OUT_1]: 'PowerInOut',
	[EASE_ID.BACK_IN]: 'backIn',
	[EASE_ID.BACK_OUT]: 'backOut',
	[EASE_ID.BACK_IN_OUT]: 'backInOut',
	[EASE_ID.BOUNCE_IN]: 'bounceIn',
	[EASE_ID.BOUNCE_OUT]: 'bounceOut',
	[EASE_ID.BOUNCE_IN_OUT]: 'bounceInOut',
} as const;

export const ANIMATION_TRIGGER_LABELS = {
	[ANIMATION_TRIGGER.ON_LOAD]: 'Page load',
	[ANIMATION_TRIGGER.ON_HOVER]: 'Hover',
	[ANIMATION_TRIGGER.ON_CLICK]: 'Click',
	[ANIMATION_TRIGGER.ON_VIEWPORT]: 'Viewport',
	[ANIMATION_TRIGGER.ON_CARD_EXPOSE_START]: 'Card transition start',
	[ANIMATION_TRIGGER.ON_CARD_EXPOSE_COMPLETE]: 'Card transition complete',
	[ANIMATION_TRIGGER.ON_ANSWER]: 'Selected answer',
	[ANIMATION_TRIGGER.ON_ANSWER_CORRECT]: 'Selected correct answer',
	[ANIMATION_TRIGGER.ON_ANSWER_INCORRECT]: 'Selected incorrect answer',
	[ANIMATION_TRIGGER.ON_CARD_ANSWER]: 'Card answer',
	[ANIMATION_TRIGGER.ON_CARD_ANSWER_CORRECT]: 'Card correct answer',
	[ANIMATION_TRIGGER.ON_CARD_ANSWER_INCORRECT]: 'Card incorrect answer',
	[ANIMATION_TRIGGER.ON_FORM_SUBMIT]: 'Form submit',
} as const;

const tooltip = (path: string) => t(`story.propFields.triggerTooltip.${path}`);
export const ANIMATION_TRIGGER_TOOLTIP = {
	[ANIMATION_TRIGGER.ON_ANSWER]: tooltip('onAnswer'),
	[ANIMATION_TRIGGER.ON_ANSWER_CORRECT]: tooltip('onAnswerCorrect'),
	[ANIMATION_TRIGGER.ON_ANSWER_INCORRECT]: tooltip('onAnswerWrong'),
	[ANIMATION_TRIGGER.ON_CARD_ANSWER]: tooltip('onCardAnswer'),
	[ANIMATION_TRIGGER.ON_CARD_ANSWER_CORRECT]: tooltip('onCardAnswerCorrect'),
	[ANIMATION_TRIGGER.ON_CARD_ANSWER_INCORRECT]: tooltip('onCardAnswerWrong'),
};
